import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { Alert } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class AlertService implements HttpService<Alert> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<Alert[]>> {
        //qo.eq.push('alert|1');
        return this.http.get<Alert[]>(env.API_URL + '/alerts', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    // id[0] customer_id
    // id[1] order_id
    // id[2] filename
    // id[3] version
    get(id: string[]) : Observable<HttpResponse<Alert>> {
        return this.http.get<Alert>(env.API_URL + '/alerts/' + id[0] + '/' + id[1] + '/' + id[2] + '/' + id[3], {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                /*
                if (resp.body != null && resp.body.download_id) {
                    resp.body.datetime = DateService.toDateString(resp.body.datetime);
                }
                */
                return resp;
            })
        );
    }

    post(t: Alert): Observable<HttpResponse<Alert>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    put(t: Alert): Observable<HttpResponse<Message>> { 
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

}
